<template>
<el-scrollbar class="main-wrapper">
  <el-breadcrumb separator=">" class="genera-breadcrumb" style="margin:0 20px">
    <el-breadcrumb-item>实操题</el-breadcrumb-item>
    <el-breadcrumb-item>添加试卷</el-breadcrumb-item>
  </el-breadcrumb>
  <el-form ref="paperForm" :model="paperForm" :rules="paperFormRules" label-width="180px" style="margin-left: 30px;margin-top: 24px">
    <el-form-item label="试卷名称" prop="name">
      <el-input v-model="paperForm.name" style="width: 500px;" ref="cursorInput" placeholder="请输入试卷名称"></el-input>
    </el-form-item>
    <el-form-item label="考试等级" prop="exam_grade">
      <el-select style="width: 500px;" v-model="paperForm.exam_grade" placeholder="选择考试等级">
        <el-option
            v-for="item in gradeClassList"
            :key="item.id"
            :label="item.name"
            :value="item.id">
        </el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="商品信息采集与处理" prop="goods_info_collect">
      <el-select style="width: 375px;" @change="selectChange($event,1)" v-model="paperForm.goods_info_collect" placeholder="请选择试题">
        <el-option
            v-for="item in collectList"
            :key="item.id"
            :label="item.op_name"
            :value="item.id">
        </el-option>
      </el-select>
      <el-input-number :disabled="true" :controls="false" v-model="collectScore" style="width: 80px;margin-left: 20px;margin-right: 10px"></el-input-number>分
    </el-form-item>
    <el-form-item label="网店装修" prop="shop_decoration">
      <el-select style="width: 375px;" @change="selectChange($event,2)"v-model="paperForm.shop_decoration" placeholder="请选择试题">
        <el-option
            v-for="item in decorationList"
            :key="item.id"
            :label="item.op_name"
            :value="item.id">
        </el-option>
      </el-select>
      <el-input-number :disabled="true" :controls="false" v-model="decorationScore" style="width: 80px;margin-left: 20px;margin-right: 10px"></el-input-number>分
    </el-form-item>
    <el-form-item label="网店管理" prop="shop_management">
      <el-select style="width: 375px;" @change="selectChange($event,3)" v-model="paperForm.shop_management" placeholder="请选择试题">
        <el-option
            v-for="item in managementList"
            :key="item.id"
            :label="item.op_name"
            :value="item.id">
        </el-option>
      </el-select>
      <el-input-number :disabled="true" :controls="false" v-model="managementScore" style="width: 80px;margin-left: 20px;margin-right: 10px"></el-input-number>分
    </el-form-item>
    <el-form-item label="网络推广" prop="network_promotion">
      <el-select style="width: 375px;" @change="selectChange($event,4)" v-model="paperForm.network_promotion" placeholder="请选择试题">
        <el-option
            v-for="item in promotionList"
            :key="item.id"
            :label="item.op_name"
            :value="item.id">
        </el-option>
      </el-select>
      <el-input-number :disabled="true" :controls="false" v-model="promotionScore" style="width: 80px;margin-left: 20px;margin-right: 10px"></el-input-number>分
    </el-form-item>
    <el-form-item label="网店客户服务" prop="store_customer_service">
      <el-select style="width: 375px;" @change="selectChange($event,5)" v-model="paperForm.store_customer_service" placeholder="请选择试题">
        <el-option
            v-for="item in serviceList"
            :key="item.id"
            :label="item.op_name"
            :value="item.id">
        </el-option>
      </el-select>
      <el-input-number :disabled="true" :controls="false" v-model="serviceScore" style="width: 80px;margin-left: 20px;margin-right: 10px"></el-input-number>分
    </el-form-item>
    <el-form-item label="电子商务数据收集与清洗" prop="data_capture_clean">
      <el-select style="width: 375px;" @change="selectChange($event,6)" v-model="paperForm.data_capture_clean" placeholder="请选择试题">
        <el-option
            v-for="item in cleanList"
            :key="item.id"
            :label="item.op_name"
            :value="item.id">
        </el-option>
      </el-select>
      <el-input-number :disabled="true" :controls="false" v-model="cleanScore" style="width: 80px;margin-left: 20px;margin-right: 10px"></el-input-number>分
    </el-form-item>
  </el-form>
  <div class="dialog-footer">
    <el-button @click="toBack">取消</el-button>
    <el-button style="margin-left: 30px" type="primary" @click="saveForm('paperForm')">保存</el-button>
  </div>
</el-scrollbar>
</template>

<script>
import {operationProblemExamModuleList, operationProblemEpOpList, operationProblemSaveOpExamPapers, operationProblemOpEpDetail} from "@/utils/apis";

export default {
  name: "AddPaperManagement",
  data(){
    return {
      paperForm:{
        id:'',
        name:'',
        exam_grade:'',
        goods_info_collect:'',
        shop_decoration:'',
        shop_management:'',
        network_promotion:'',
        store_customer_service:'',
        data_capture_clean:'',
      },
      paperFormRules:{
        name:[
          { required: true, message: '请输入试卷名称', trigger: 'blur' },
          { min: 2, max: 18, message: '长度在 2 到 18 个字符', trigger: 'blur' }
        ],
        exam_grade:[
          { required: true, message: '请选择考试等级', trigger: 'change' }
        ],
        goods_info_collect:[
          { required: true, message: '请选择商品信息采集与处理', trigger: 'change' }
        ],
        shop_decoration:[
          { required: true, message: '请选择网店装修', trigger: 'change' }
        ],
        shop_management:[
          { required: true, message: '请选择网店管理', trigger: 'change' }
        ],
        network_promotion:[
          { required: true, message: '请选择网络推广', trigger: 'change' }
        ],
        store_customer_service:[
          { required: true, message: '请选择网店客户服务', trigger: 'change' }
        ],
        data_capture_clean:[
          { required: true, message: '请选择电子商务数据收集与清洗', trigger: 'change' }
        ],
      },
      gradeClassList:[],
      collectList:[],
      collectScore:void 0,
      decorationList:[],
      decorationScore:void 0,
      managementList:[],
      managementScore:void 0,
      promotionList:[],
      promotionScore:void 0,
      serviceList:[],
      serviceScore:void 0,
      cleanList:[],
      cleanScore:void 0,
    }
  },
  mounted() {
    this.getExamModuleList();
    this.getTestQuestions();
    if(this.$route.query.id){
      this.getEditData(this.$route.query.id)
    }
  },
  methods:{
    //获取编辑数据
    getEditData(id){
      let params = {
        id:id
      }
      operationProblemOpEpDetail(params).then((res)=>{
        this.paperForm.id = res.data.id;
        this.paperForm.name = res.data.name;
        this.paperForm.data_capture_clean = res.data.data_capture_clean;
        this.paperForm.exam_grade = res.data.exam_grade;
        this.paperForm.goods_info_collect = res.data.goods_info_collect;
        this.paperForm.network_promotion = res.data.network_promotion;
        this.paperForm.shop_decoration = res.data.shop_decoration;
        this.paperForm.shop_management = res.data.shop_management;
        this.paperForm.store_customer_service = res.data.store_customer_service;
        this.selectChange(this.paperForm.goods_info_collect,1);
        this.selectChange(this.paperForm.shop_decoration,2);
        this.selectChange(this.paperForm.shop_management,3);
        this.selectChange(this.paperForm.network_promotion,4);
        this.selectChange(this.paperForm.store_customer_service,5);
        this.selectChange(this.paperForm.data_capture_clean,6);
      }).catch((err)=>{
        console.log('err',err)
      })
    },
    // 获取考试等级
    getExamModuleList(){
      operationProblemExamModuleList().then((res)=>{
        this.gradeClassList = res.data;
      }).catch((err)=>{
        console.log('err', err)
      })
    },
    // 实操题试题列表
    getTestQuestions(){
      operationProblemEpOpList().then((res)=>{
        this.collectList = res.data.goodsInfoCollection;
        this.decorationList = res.data.shopDecoration;
        this.managementList = res.data.shopManagement;
        this.promotionList = res.data.networkPromotion;
        this.serviceList = res.data.customerService;
        this.cleanList = res.data.dataCollectAndClean;
      }).catch((err)=>{
        console.log('err',err)
      })
    },
    selectChange(val,num){
      let list = [];
      switch (num){
        case 1:
          list = this.collectList;
          break;
        case 2:
          list = this.decorationList;
          break;
        case 3:
          list = this.managementList;
          break;
        case 4:
          list = this.promotionList;
          break;
        case 5:
          list = this.serviceList;
          break;
        case 6:
          list = this.cleanList;
          break;
      }
      list.forEach(item=>{
        if(item.id === val){
          switch (num){
            case 1:
              this.collectScore = item.score;
              break;
            case 2:
              this.decorationScore = item.score;
              break;
            case 3:
              this.managementScore = item.score;
              break;
            case 4:
              this.promotionScore = item.score;
              break;
            case 5:
              this.serviceScore = item.score;
              break;
            case 6:
              this.cleanScore = item.score;
              break;
          }
        }
      })
    },
    saveForm(formName){
      this.$refs[formName].validate((valid)=>{
        if(valid){
          let formData = new FormData();
          formData.append('name', this.paperForm.name);
          formData.append('exam_grade', this.paperForm.exam_grade);
          formData.append('goods_info_collect', this.paperForm.goods_info_collect);
          formData.append('shop_decoration', this.paperForm.shop_decoration);
          formData.append('shop_management', this.paperForm.shop_management);
          formData.append('network_promotion', this.paperForm.network_promotion);
          formData.append('store_customer_service', this.paperForm.store_customer_service);
          formData.append('data_capture_clean', this.paperForm.data_capture_clean);
          if(this.paperForm.id){
            formData.append('id', this.paperForm.id)
          }
          operationProblemSaveOpExamPapers(formData).then((res)=>{
            this.$message.success(res.msg);
            this.$router.go(-1)
          }).catch((err)=>{
            console.log('err', err)
          })
        } else {
          return false
        }
      })
    },
    toBack(){
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped lang="scss">
.main-wrapper{
  box-sizing: border-box;
  height: 100%;
  display: flex;
  flex-direction: column;
  ::v-deep .el-scrollbar__wrap {
    overflow-x: hidden;
    .el-scrollbar__view {
      padding: 0px 20px;
    }
  }
  .dialog-footer{
    text-align: center;
    margin: 150px 0 50px;
  }
}
</style>